import React from 'react';

import { smallButtonStyle } from '../../../styles/constants';

/**
 * Props for the SmallButton component
 */
export interface SmallButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Function called when button is clicked */
  onClick: () => void;
  /** Whether the button is disabled */
  disabled?: boolean;
  /** Button label text */
  text: string;
}

/**
 * Small Button Component
 *
 * A compact version of the standard button for use in toolbars,
 * list items, or areas where space is limited.
 *
 * @example
 * <SmallButton
 *   text="Edit"
 *   onClick={handleEdit}
 * />
 */
export const SmallButton: React.FC<SmallButtonProps> = ({ onClick, disabled, text, ...props }) => {
  return (
    <button style={smallButtonStyle} onClick={() => onClick()} disabled={disabled} {...props}>
      {text}
    </button>
  );
};

export default SmallButton;
